export default __webpack_public_path__ + "static/media/membre_zino.1db8b78c.jpg";